import styled, { FlattenInterpolation, ThemeProps } from 'styled-components';
import { $black } from 'styles/global-styles';
import { TSRadioSizeEnum } from 'enums/TSRadioVariants';

export const SCRadioButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    flex: none;
    order: 0;
    flex-wrap: nowrap;
    label {
        color: #231f20;
        font-size: 18px;
        line-height: 21px;
        letter-spacing: 0.56px;
        font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
            'Open Sans', 'Helvetica Neue', sans-serif;
    }
`;

export const SCRadioButtonLabel = styled.div<{
    $color?: string | FlattenInterpolation<ThemeProps<any>>;
    $size?: TSRadioSizeEnum;
}>`
    font-size: 3px;
    line-height: 21px;
    letter-spacing: 0.56px;
    color: #231f20;
    flex: none;
    order: 1;
    span {
        color: #231f20;
        font-size: ${({ $size }): string => ($size === TSRadioSizeEnum.LARGE ? '21px' : '18px')};
        line-height: 21px;
        letter-spacing: 0.56px;
        font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
            'Open Sans', 'Helvetica Neue', sans-serif;
        svg:not(.tooltip-icon) {
            fill: ${({ $color }): string | FlattenInterpolation<ThemeProps<any>> => $color || $black};
            margin-right: ${({ $size }): string => ($size === TSRadioSizeEnum.LARGE ? '8px' : '3px')};
        }
    }
`;

export const SCRadioGroup = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: none;
    order: 0;
    padding: 0 0 0 10px;
    flex-wrap: nowrap;
`;

export const SCRadio = styled.div<{ $orientation?: 'horizontal' | 'vertical' }>`
    display: flex;
    flex-direction: ${({ $orientation }): string => ($orientation === 'vertical' ? 'column' : 'row')};
    align-items: flex-start;
    flex: none;
    order: 0;
    padding: 0;
    flex-wrap: nowrap;
    gap: 12px;
    span {
        padding: 0;
    }
`;

export const SCFormLabel = styled.div`
    label {
        line-height: 21px;
    }
`;
